define('viewModels/privileged/qm/EvaluationView',[
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'moment',
    'viewModels/privileged/composer/forms/formEditor/Evaluation',
    'viewModels/privileged/composer/forms/formEditor/FormEditorState',
    'viewModels/privileged/qm/CreateCalibrationView',
    'viewModels/privileged/qm/policies/editors/DateEditorView',
    'services/qm/qualityAuth',
    'services/qm/qualityBroadcast',
    'services/authService',
    'services/loggingService',
    'services/navHelper',
    'services/qualityManagementService',
    'services/composer/evaluationFormService',
    'services/composer/qualityService',
    'services/timeZoneService',
    'services/featureToggleService',
    'models/composer/forms/Evaluation',
    'services/toastService',
    'viewModels/privileged/qm/util/BroadCastEnum',
    'util/errorCallbackFactory',
    'util/dateTimeConstant',
    'lib/jstz',
    'viewModels/ViewModel',
    'lib/moment-timezone'
], function (_,
             ko,
             Promise,
             moment,
             Evaluation,
             FormEditorState,
             CreateCalibrationView,
             DateEditorView,
             qualityAuth,
             qualityBroadcast,
             authService,
             LOG,
             navHelper,
             qualityManagementService,
             evaluationFormService,
             qualityService,
             timeZoneService,
             featureToggleService,
             EvaluationModel,
             toasts,
             BroadcastEnum,
             errorCallbackFactory,
             dateTimeConstant,
             jstz,
             ViewModel) {
    'use strict';


    // TODO: Make sure unit tests cover filling of existing QM answers into evaluation VM
    // TODO: Update unit tests for saveEvaluatorEvaluation and submitEvaluatorEvaluation
    // TODO: Make sure unit tests cover release date options for evaluator context
    // TODO: Make sure to add unit tests for saveAgentEvaluation

    var EvaluationWrapper = ViewModel.extend(function (conversationId, assignedEvaluationId, isAdminRoute, deleteEvaluationCallback) {
        var self = this;

        self.evaluationView = ko.observable();
        self.loading = ko.observable(true);
        self.saving = ko.observable(false);
        self.isAdminContext = ko.observable(isAdminRoute);
        self.agentConfirmation = ko.observable(false);
        self.agentHasRead = ko.observable(false);
        self.agentComments = ko.observable();
        self.releaseDescriptionLabel = ko.observable();
        self.releaseOptions = ko.observableArray();
        self.isSubmitted = ko.observable(false);
        self.agent = ko.observable();
        self.agentId = ko.observable();
        self.releaseDate = ko.observable();
        self.evaluationAssignedDate = ko.observable(); //this is the assigned date
        self.evaluationCreatedDate = ko.observable();
        self.evaluationProgress = ko.observable();
        self.evaluationProgressIcon = ko.observable();
        self.evaluationProgressText = ko.observable();
        self.evaluationProgressArrow = ko.observable();
        self.evaluationProgressClass = ko.observable();
        self.isPartOfCalibration = ko.observable(false);
        self.currentEvaluatorId = authService.principalId();
        self.useAsScoringIndex = ko.observable(false);
        self.maxReleaseDate = null;
        self.maxScoreDate = null;
        self.maxDeleteDate = null;
        self.maxAgentReviewDate = null;
        self.scoringExpired = ko.observable(false);
        self.deletingExpired = ko.observable(false);
        self.agentReviewExpired = ko.observable(false);
        self.createCalibrationView = ko.observable();
        self.isQualityAdmin = authService.principalId() && authService.hasAnyAuthorization(['qualityAdmin']);
        self.finishedStatus = ko.observable();
        self.canEditScore = ko.observable(qualityAuth.canEditScore() || qualityAuth.canEditEvaluation());
        self.canEditOrSaveEvaluation = ko.observable(qualityAuth.canEditEvaluation() || qualityAuth.canEditScore());
        self.canDeleteEvaluation = ko.observable(qualityAuth.canDeleteEvaluation());
        self.canAddCalibration = ko.observable(qualityAuth.canAddCalibration());
        self.selectedReleaseOption = ko.observable();
        self.customTimezone = ko.observable();
        self.selectedTimeZone = ko.observable();
        self.errorStatus = ko.observable();

        self.customDate = ko.observable(moment());

        var formEditorState = new FormEditorState();

        self.setReleaseOptions = function() {
            var timeZoneName = jstz.determine().name();
            var format = 'MMMM Do YYYY, h:mm:ss a zz';

            self.releaseOptions([
                { id: 'now', name: ko.i18n.renderString("playback.evaluation.release.now.item"), infoText: moment().tz(timeZoneName).format(format) },
                { id: 'eod', name: ko.i18n.renderString("playback.evaluation.release.endOfDay.item"), infoText: moment().tz(timeZoneName).endOf('day').format(format)},
                { id: 'eow', name: ko.i18n.renderString("playback.evaluation.release.endOfWeek.item"), infoText: moment().tz(timeZoneName).endOf('week').format(format)},
                { id: 'custom', name: ko.i18n.renderString("playback.evaluation.release.custom.item") },
                { id: 'never', name: ko.i18n.renderString("playback.evaluation.release.never")}
            ]);

            if (self.evaluation &&
                self.evaluation.status == qualityManagementService.FINISHED && !self.evaluation.calibration) {
                if (self.evaluation.releaseDate) {
                    var now = moment();
                    var releaseDate = moment(self.evaluation.releaseDate);
                    self.releaseOptions().unshift(
                        { id: 'unchanged', name: ko.i18n.renderString("playback.evaluation.release.unchanged.item", { releaseDate : ko.i18n.formatDate(releaseDate, "LLLL") }) }
                    );

                    var visibleReleaseDate = ko.i18n.formatDate(releaseDate, "LLLL");
                    if (now.isAfter(releaseDate)) {
                        self.releaseDescriptionLabel(ko.i18n.renderString('playback.evaluation.postrelease.label', { releaseDate: visibleReleaseDate }));
                    } else {
                        self.releaseDescriptionLabel(ko.i18n.renderString('playback.evaluation.prerelease.label', { releaseDate: visibleReleaseDate }));
                    }
                } else {
                    self.releaseDescriptionLabel(ko.i18n.renderString('playback.evaluation.norelease.label'));
                }
            } else {
                self.releaseDescriptionLabel(undefined);
            }
            self.selectedReleaseOption(self.releaseOptions()[0]);
        };

        formEditorState.setFinishedReviewMode();

        self.isEvaluatorActionMode = self.computed(function () {
            return formEditorState.modes.isEvaluatorActionMode();
        });

        self.isAgentReviewMode = self.computed(function () {
            return formEditorState.modes.isAgentReviewMode();
        });

        self.isFinishedReviewMode = self.computed(function () {
            return formEditorState.modes.isFinishedReviewMode();
        });

        self.canToggleReviewMode = self.computed(function () {
            if (!formEditorState.modes.isFinishedReviewMode() &&
                !formEditorState.modes.isAgentReviewMode()  ||
                self.isPartOfCalibration()) {
                return false;
            }

            var canSetAgentReviewState = !!authService.principalId() &&
                (authService.principalId() === self.agentId());

            var canSetFinishedReviewState = (self.canAddCalibration() && !self.isPartOfCalibration()) ||
                self.canEditScore();

            return canSetAgentReviewState && canSetFinishedReviewState;
        });

        self.toggleReviewMode = function () {
            if (self.canToggleReviewMode() && self.currentEvaluatorId !== self.agentId
                ) {
                if (self.isAdminContext()) {
                    navHelper.navigateTo(window.location.hash.replace("admin", "agent"));
                } else {
                    navHelper.navigateTo(window.location.hash.replace("agent", "admin"));
                }
            }
        };

        self.searchReleaseOptions = function(searchString) {
            var filteredOptions = self.releaseOptions();
            if (searchString.length > 0) {
                filteredOptions = _.filter(self.releaseOptions(), function (option) {
                    return option.name.toLowerCase().indexOf(searchString.toLowerCase()) != -1;
                });
            }
            return Promise.resolve(filteredOptions);
        };

        self.isCustom = self.computed(function(){
            return self.selectedReleaseOption() && self.selectedReleaseOption().id == "custom";
        });

        var updateEvaluationAnswers = function(state) {
            // Return empty object to return a default error message
            if (!self.evaluationView()) { return Promise.reject({}); }
            if (self.saving()) { return Promise.reject({}); }

            var evaluationData = self.evaluationView();
            if ( evaluationData ) {
                var notificationTitle;
                var notificationMsg;
                var notificationData = {};
                var answers = evaluationData.getQualityAnswerData();
                var updateEvaluation = {
                    answers: answers,
                    status: state
                };
                if (state == qualityManagementService.FINISHED) {
                    var validationErrors = evaluationData.validationsForSubmission();
                    if (validationErrors.length !== 0) {
                        return Promise.reject({ errors: validationErrors });
                    }

                    // The evaluator is submitting an evaluation
                    var releaseDate = null;
                    if (!self.evaluation.calibration) {
                        if (self.selectedReleaseOption() ) {
                            if (self.selectedReleaseOption().id == 'now') {
                                releaseDate = moment();
                            } else if (self.selectedReleaseOption().id == 'eod') {
                                releaseDate = moment().endOf('day');
                            } else if (self.selectedReleaseOption().id == 'eow') {
                                releaseDate = moment().endOf('week');
                            } else if (self.selectedReleaseOption().id === 'never'){
                                updateEvaluation.neverRelease = true;
                            }
                            else if (self.selectedReleaseOption().id == 'custom'){
                                if (moment(self.customDate()).isBefore(moment())){
                                    self.customDate(moment());
                                }
                                var rawDateTime = moment(self.customDate()).toISOString();
                                if (self.selectedTimeZone()){
                                    var tempReleaseDate = moment(rawDateTime).format("YYYY-MM-DD hh:mm:ss a");
                                    releaseDate = moment.tz(tempReleaseDate, "YYYY-MM-DD hh:mm:ss a", self.selectedTimeZone().id);
                                } else {
                                    releaseDate = moment(self.customDate()).tz(jstz.determine().name()); //current time zone
                                }
                            }
                        }

                        notificationTitle = "playback.evaluation.notification.evaluator.submit.title";
                        notificationMsg = "playback.evaluation.notification.evaluator.submitNoRelease.msg";
                        if (releaseDate) {
                            updateEvaluation.releaseDate = releaseDate.toISOString();
                            notificationMsg = "playback.evaluation.notification.evaluator.submitAgentEval.msg";
                        }
                        notificationData = { releaseDate: ko.i18n.formatDate(releaseDate, dateTimeConstant.LongDate) };

                    } else {
                        notificationMsg = "playback.evaluation.notification.evaluator.submitCalibrationEval.msg";
                    }
                } else {
                    // The evaluator is saving the current progress of an evaluation
                    notificationTitle = "playback.evaluation.notification.evaluator.save.title";
                    notificationMsg = "playback.evaluation.notification.evaluator.save.msg";
                }

                self.saving(true);
                return qualityManagementService.updateAssignedEvaluation(conversationId, assignedEvaluationId, updateEvaluation)
                .then(function(response) {
                    self.displayEvaluationProgress(response.status);
                    // Success - update models as appropriate
                    self.evaluation = response;
                    var ev = self.evaluationView();
                    ev.fillQualityAnswerData(self.evaluation.answers);

                    // Display a notification that it happened
                    toasts.notifyMessage(notificationTitle, {
                        bodyMessageKey: notificationMsg,
                        messageData: notificationData,
                        icon: "pc-icon-messages"
                    });
                })
                .finally(function() {
                    self.saving(false);
                });

            }
        };

        self.submitEvaluatorEvaluation = function() {
            updateEvaluationAnswers(qualityManagementService.FINISHED)
                .then(function() {
                    navHelper.navigateTo('dashboard/qualityEvaluator');
                })
                .catch(function (error) {
                    if (error.errors) {
                        formEditorState.shouldShowSubmitErrors(true);
                    }

                    errorCallbackFactory.createCallback({ namespace: 'playback.evaluationAnswerEvaluatorSubmitRequest' })(error);
                })
                .finally(function() {
                    if (self.maxScoreDate) {
                        self.scoringExpired(self.maxScoreDate.isBefore(moment()));
                    }
                });
        };

        self.saveEvaluatorEvaluation = function() {
            updateEvaluationAnswers(qualityManagementService.INPROGRESS)
                .catch(errorCallbackFactory.createCallback({ namespace: 'playback.evaluationAnswerEvaluatorSaveRequest' }))
                .finally(function() {
                    if (self.maxScoreDate) {
                        self.scoringExpired(self.maxScoreDate.isBefore(moment()));
                    }
                });
        };

        self.deleteEvaluation = function() {
            deleteEvaluationCallback(conversationId, assignedEvaluationId);
            if (self.maxDeleteDate) {
                self.deletingExpired(self.maxDeleteDate.isBefore(moment()));
            }
        };

        var search = function (objects, searchTerm, getText) {
            var results;
            if (_.isEmpty(searchTerm)) {
                results = ko.unwrap(objects);
            } else {
                searchTerm = searchTerm.toLowerCase();
                results = _.filter(ko.unwrap(objects), function (obj) {
                    var name = getText(obj);
                    return name.indexOf(searchTerm) > -1;
                });
            }
            return results;
        };

        function stringStartsWith(value, prefix) {
            return value.indexOf(prefix, 0) === 0;
        }

        function stringEndsWith(value, suffix) {
            return value.lastIndexOf(suffix, value.length - suffix.length) === value.length - suffix.length;
        }

        var searchableTimezones = ko.observableArray();

        self.searchTimezones = function(searchTerm){
            var timezonePromise;

            if (!searchableTimezones() || searchableTimezones().length < 1){
                timezonePromise = timeZoneService.getTimeZoneList()
                    .then(function(result){
                        searchableTimezones(result);
                    });
            } else {
                timezonePromise = Promise.resolve(searchableTimezones());
            }

            return timezonePromise.then(function(){
                var searchableTimeZones = searchableTimezones();

                var detectedTimeZoneName = jstz.determine().name();
                var detectedTzParts = detectedTimeZoneName.split('/');
                var detectedTzRegion = detectedTzParts[0];
                var detectedTzCity = detectedTzParts[detectedTzParts.length - 1];
                var currentTimeZone = _.find(searchableTimeZones, function(timeZone) {
                    return stringStartsWith(timeZone.id, detectedTzRegion) && stringEndsWith(timeZone.id, detectedTzCity);
                });

                if (currentTimeZone){
                    self.selectedTimeZone(currentTimeZone);
                }

                searchableTimeZones.sort(function (a, b) {
                    if (a.offset < b.offset){
                        return -1;
                    } else {
                        return 1;
                    }
                });
                return search(searchableTimeZones, searchTerm, function (timeZone) {
                    return timeZone.name.toLowerCase();
                });
            });
        };

        self.searchTimezones();

        self.saveAgentEvaluation=function() {
            if (!self.evaluationView()) { return; }
            if (self.saving()) { return; }
            if (self.evaluation) {
                self.saving(true);
                var updateEvaluation = {
                    agentHasRead: self.agentConfirmation()
                };
                if (self.agentComments()) {
                    var newAnswers = self.evaluation.answers;
                    newAnswers.agentComments = self.agentComments();
                    updateEvaluation.answers = newAnswers;
                }

                qualityManagementService.updateAssignedEvaluation(self.evaluation.conversation.id, assignedEvaluationId, updateEvaluation)
                    .then(function() {
                        self.agentHasRead (self.agentConfirmation());

                        // Display a notification that it happened
                        toasts.notifyMessage('playback.evaluation.notification.agent.save.title', {
                            bodyMessageKey: 'playback.evaluation.notification.agent.save.msg',
                            messageData: {},
                            icon: "pc-icon-messages"
                        });

                        // Go on back to the agent dashboard evaluation list
                        navHelper.navigateTo('agentDashboard/evaluation');
                    })
                    .catch(errorCallbackFactory.createCallback({ namespace: 'playback.evaluationAnswerAgentSaveRequest' }))
                    .finally(function() {
                        if (self.maxAgentReviewDate) {
                            self.agentReviewExpired(self.maxAgentReviewDate.isBefore(moment()));
                        }
                        self.saving(false);
                    });
            }
        };

        self.reScoreEvaluation = function() {
            formEditorState.setEvaluatorActionMode();
        };

        // TODO: This should probably use breadcrumbs instead of a hard destination
        self.agentContextHref = self.computed(function() {
            return "#/analytics/agents/evaluations/me";
        });

        self.setFinishedReviewState = function(){
            formEditorState.setFinishedReviewMode();
            getAssignedEvaluation();
        };

        self.displayEvaluationProgress = function(status) {
            if(status === qualityManagementService.PENDING){
                self.evaluationProgress(ko.i18n.renderString('evaluation.pending'));
                self.evaluationProgressClass('evaluation-pending');
                self.evaluationProgressArrow('pending-arrow');
                self.evaluationProgressIcon('fa-circle-o');
                self.evaluationProgressText('pending-text');
            } else if(status === qualityManagementService.INPROGRESS){
                self.evaluationProgress(ko.i18n.renderString('evaluation.inProgress'));
                self.evaluationProgressClass('evaluation-in-progress');
                self.evaluationProgressArrow('in-progress-arrow');
                self.evaluationProgressIcon('pc-icon-progress-pie');
                self.evaluationProgressText('in-progress-text');
            } else if(status === qualityManagementService.FINISHED){
                self.evaluationProgress(ko.i18n.renderString('evaluation.finished'));
                self.evaluationProgressClass('evaluation-completed');
                self.evaluationProgressArrow('completed-arrow');
                self.evaluationProgressIcon('fa-check-circle');
                self.evaluationProgressText('completed-text');
            }
        };

        self.subscribe(self.useAsScoringIndex, function(newValue) {
            if(newValue) {
                self.createCalibrationView(self.subView(CreateCalibrationView, self.evaluation));
            } else {
                self.disposeSubView(self.createCalibrationView());
                self.createCalibrationView(undefined);
            }
        });

        function getAssignedEvaluation(){
            var loadStage = "Loading evaluation (id: " + assignedEvaluationId + ")";
            LOG.info(loadStage);
            var options = {};
            options.expand = ["evaluationForm", "agent", "evaluator"];

            qualityManagementService.getAssignedEvaluation(conversationId, assignedEvaluationId, options)
                .then(function (evaluation) {
                    self.evaluation = evaluation;
                    if (self.evaluation.resourceId){
                        qualityBroadcast.publish(conversationId, BroadcastEnum.HANDLE_EMAIL_EVALUATION_TOPIC, self.evaluation);
                    }
                    self.agentConfirmation(evaluation.agentHasRead);
                    self.agentHasRead(evaluation.agentHasRead);
                    self.evaluationAssignedDate = ko.i18n.formatDate(moment(evaluation.assignedDate), "LLLL");
                    self.evaluationCreatedDate = evaluation.createdDate ? moment(evaluation.createdDate) : moment(evaluation.assignedDate);
                    self.agentId(evaluation.agent.id);

                    self.agentName = evaluation.agent.name;
                    self.evaluatorName = evaluation.evaluator.name;
                    self.releaseDate = evaluation.releaseDate ? ko.i18n.formatDate(moment(evaluation.releaseDate), "LLLL") : ko.i18n.renderString('playback.evaluation.never');
                    var now = moment();
                    self.minReleaseDate = now;
                    self.maxReleaseDate = self.evaluationCreatedDate.clone().add(45, 'days');
                    self.maxScoreDate = self.evaluationCreatedDate.clone().add(45, 'days');
                    self.maxDeleteDate = self.evaluationCreatedDate.clone().add(90, 'days');
                    self.maxAgentReviewDate = self.evaluationCreatedDate.clone().add(90, 'days');
                    self.scoringExpired(self.maxScoreDate.isBefore(now));
                    self.deletingExpired(self.maxDeleteDate.isBefore(now));
                    self.agentReviewExpired(self.maxAgentReviewDate.isBefore(now));
                    if(evaluation.hasOwnProperty('calibration')){
                        self.isPartOfCalibration(true);
                    }

                    if (evaluation.answers && evaluation.answers.agentComments) {
                        self.agentComments(evaluation.answers.agentComments);
                    }

                    // Set the evaluation (form editor) mode, depending on the context that the viewmodel was created with and the state of the evaluation
                    if (!self.isAdminContext()) {
                        if (evaluation.agentHasRead) {
                            // If the agent has marked it as read, it's review only for them
                            formEditorState.setFinishedReviewMode();
                        } else {
                            formEditorState.setAgentReviewMode();
                        }
                    } else {
                        if (evaluation.status === qualityManagementService.FINISHED) {
                            // If the evaluator has finished the evaluation, no more changes can be made
                            formEditorState.setFinishedReviewMode();
                        } else {
                            formEditorState.setEvaluatorActionMode();
                        }
                    }

                    self.displayEvaluationProgress(evaluation.status);
                    self.finishedStatus(evaluation.status === qualityManagementService.FINISHED);

                    _.each(evaluation.evaluationForm.questionGroups, function (curGroup) {
                        curGroup.questions = _.filter(curGroup.questions, function (curQuestion) {
                            return (curQuestion && curQuestion.type !== "freeTextQuestion");
                        });
                    });

                    var evaluationForm = new EvaluationModel(evaluation.evaluationForm);

                    // Back-fill evaluationModel with answers
                    loadStage = "Creating evaluation form view";
                    self.evaluationView(self.subView(Evaluation, evaluationForm, null, formEditorState));
                    loadStage = "Populating evaluation form view with any existing answers";
                    var ev = self.evaluationView();

                    // if no existing answers are present then set the defaults
                    if(self.evaluation.answers === undefined){
                        //select default answers
                        ev.selectDefaultAnswers();
                    } else {
                        ev.fillQualityAnswerData(self.evaluation.answers);
                    }

                    self.setReleaseOptions();
                })
                .catch(function(error) {
                    if (error && error.details && error.details.status === 403){
                        self.errorStatus = error.details.status;
                    }
                    LOG.warn("Evaluation load failed", { stage: loadStage });
                })
                .finally(function () {
                    self.loading(false);
                });
        }
        getAssignedEvaluation();

        qualityBroadcast.subscribe(conversationId, BroadcastEnum.ACTIVATED_EVALUATION + assignedEvaluationId, function(){
            if (self.evaluation && self.evaluation.resourceId){
                qualityBroadcast.publish(conversationId, BroadcastEnum.HANDLE_EMAIL_EVALUATION_TOPIC, self.evaluation);
            }
            if (self.evaluation && !self.evaluation.resourceId){
                qualityBroadcast.publish(conversationId, BroadcastEnum.HANDLE_EMAIL_EVALUATION_TOPIC, {noSessionId: true});
            }
        });

    });
    return EvaluationWrapper;
});

